export class CreateContainerJobRequestPortData{
  public seaPortCode: string = '';
  public useInlandPort: boolean = false;
  public inlandPortCode: string = '';
  public scheduledVesselVisitId: number | null = null;
  public vesselCode: string | null = null;
  public vesselEta: Date | null = null;
  public vesselEtd: Date | null = null;
  public receivalCommenceDate: Date | null = null;
  public receivalCutoffDate: Date | null = null;
}
